<script>
import Navbar from "@/components/navbar";
import FooterBG from "@/components/footer-bg";
import Courses from "@/components/math-courses-bg";

export default {
  components: {
    Navbar,
    // Partners,
    Courses,
    // Blog,
    // Contact,
    FooterBG,
  }
};
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  #aboutText
{
  flex-direction: column;
}
}

</style>
<template>
  <div>
    <Navbar />

    <div v-scroll-spy>
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{'background-image': 'url(' + require('@/assets/images/fanmath-images/courses3.jpg') + ')', 'background-size': 'cover','background-position': 'center'}"
      >
      <div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 class="home-title">Нашите курсове</h1>
                  <h4 class="home-small-title"></h4>
                  <p
                    class="padding-t-15 home-desc mx-auto"
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
        <!-- <vue-particles class="position-relative" color="#FFF"></vue-particles> -->
      </section>

      <Courses />
      <!-- <Blog /> -->
      <!-- <Contact /> -->
      <!-- <Partners /> -->
      <FooterBG />
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>